import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { cashConverter, formatPathDoc, formatText } from "../../../../../utils";
import FarmerPayAddModal from "./modal/FarmerPayAddModal";
import useModalToggle from "../../../../../custom_hooks/useModalToggle";
import svg12 from "../../../../../assets/svg/svg12.svg";
import svg63 from "../../../../../assets/svg/svg63.svg";
import FarmerPayCard from "./FarmerPayCard";
import {
  fetchData,
  fetchFiles,
} from "../../../../../features/fetch/fetchSlice";
import moment from "moment";
import CardLoading from "../../../../../components/CardLoading";
import { Dropdown, Table } from "antd";
import ConfirmModal from "../../../../../components/ConfirmModal";
import BreadCrumb from "../../../../../layout/BreadCrumb";
import { save } from "../../../../../features/save/saveSlice";
import toast from "react-hot-toast";

function FarmerPayTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "api/v2/payments/getPaymentsHistory";
  const urlPaymentType = "api/v2/paymentTypes/get";
  const urlCard = "api/v2/flid/projects/getFlidPaymentSummary";
  const { loading, data, dataCard, count, activeObjexpressions } = useSelector(
    (state) => ({
      loading: state.fetch.loading,
      data: state.fetch.data[url] || [],
      dataCard: state.fetch.data[urlCard] || [],
      count: state.fetch.count[url] || 0,
      activeObjexpressions: state.obj.activeObj["expressions"],
    })
  );

  const [prodd, setProdd] = useState("");

  const { open, handleCancel, handleOpen } = useModalToggle();

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };
  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "api/v2/flid/projects/pushToInstallation",
        projectId: activeObjexpressions?.projectId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message); 
      await navigate('/expression-of-interest')
      await setOpenDelete(false)
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const handleEdit = async (item) => {
    await setProdd(item);
    await handleOpen();
  };

  const handleAdd = async () => {
    await setProdd("");
    await handleOpen();
  };

  const downloadFile = async (item) => {
    try {
      const res = await dispatch(fetchFiles({ file: item?.paymentFileUrl }));
      if (res?.payload) {
        window.open(res.payload, "_blank");
      }
    } catch (error) {
      console.error("Failed to open file:", error);
    }
  };

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Payment Date",
      dataIndex: "paymentDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.paymentDate).valueOf() - moment(b.paymentDate).valueOf(),
    },
    {
      title: "Paid By",
      dataIndex: "paymentPayerName",
      sorter: (a, b) => a.paymentPayerName.localeCompare(b.paymentPayerName),
    },
    {
      title: "Amount (Kes)",
      dataIndex: "paymentAmount",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.paymentAmount.localeCompare(b.paymentAmount),
    },
    {
      title: "Via",
      dataIndex: "paymentType",
      sorter: (a, b) => a.paymentType.localeCompare(b.paymentType),
    },
    {
      title: "Receipt",
      dataIndex: "paymentCode",
      sorter: (a, b) => a.paymentCode.localeCompare(b.paymentCode),
    },
    {
      title: "File",
      render: (item) => {
        return (
          <div
            className="cursor-pointer text-darkBlue"
            onClick={() => downloadFile(item)}
          >
            {formatPathDoc(item?.paymentFileUrl)}
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "paymentStatus",
      render: (item) => {
        const colors = {
          CONFIRMED: "#B1E17C",
          NOT_CONFIRMED: "#E5E7E9",
        };

        return (
          <div
            className={`${
              item === "NOT_CONFIRMED" ? "text-black" : "text-[#FFF]"
            }  inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]`}
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },
    {
      title: "Actions",
      render: (item) => (
        <>
          <button onClick={() => handleEdit(item)}>
            <img src={svg12} alt="svg12" />
          </button>
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        paymentProjectId: activeObjexpressions?.projectId,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  async function fetchCardData() {
    await dispatch(
      fetchData({
        url: urlCard,
        projectId: activeObjexpressions?.projectId,
        limit: null,
        start: 0,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
    fetchCardData();
    dispatch(
      fetchData({
        url: urlPaymentType,
        limit: null,
        start: 0,
      })
    );
  }, []);

  if (loading) return <CardLoading />;
  return (
    <div className="white_card mt-[1.25rem]">
      <div className="flex lg:flex-row flex-col gap-[1.25rem] lg:items-center justify-between">
        <div className="form-add-h !text-[1rem]">Farmers Payment History</div>

        <div className="flex lg:flex-row flex-col lg:items-center gap-[.62rem]">
          <div className="w-[150px]">
            <button onClick={() => handleAdd()} className="cstm-btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="11"
                viewBox="0 0 10 11"
                fill="none"
              >
                <g clip-path="url(#clip0_5836_14348)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.66683 1.50065C5.66683 1.13246 5.36835 0.833984 5.00016 0.833984C4.63198 0.833984 4.3335 1.13246 4.3335 1.50065V4.83398H1.00016C0.631973 4.83398 0.333496 5.13246 0.333496 5.50065C0.333496 5.86884 0.631973 6.16732 1.00016 6.16732H4.3335V9.50065C4.3335 9.86885 4.63198 10.1673 5.00016 10.1673C5.36835 10.1673 5.66683 9.86885 5.66683 9.50065V6.16732H9.00016C9.36836 6.16732 9.66683 5.86884 9.66683 5.50065C9.66683 5.13246 9.36836 4.83398 9.00016 4.83398H5.66683V1.50065Z"
                    fill="#424242"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_5836_14348">
                    <rect
                      width="9.33333"
                      height="9.33333"
                      fill="white"
                      transform="translate(0.333496 0.833984)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <span className="">Add Record</span>
            </button>
          </div>
          <div className="w-[200px]">
            <button
              onClick={() =>
                dataCard?.percentagePaid > "20" ? handleOpenDelete() : null
              }
              className={`cstm-btn !bg-[#CECECE] ${
                dataCard?.percentagePaid > "20"
                  ? "cursor-pointer"
                  : "cursor-not-allowed"
              }`}
            >
              <img src={svg63} alt="svg63" />
              <span className="">Push to Installation</span>
            </button>
          </div>
        </div>
      </div>
      <FarmerPayCard />

      <Table
        rowSelection={false}
        className="mt-[1.25rem] w-full"
        scroll={{
          x: 1200,
        }}
        rowKey={(record) => record?.paymentId}
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={{
          position: ["bottomRight"],
          current: pageIndex + 1,
          total: count,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPageIndex(page - 1);
            setPageSize(size);
            fetchTableData(page - 1, size);
          },
          showSizeChanger: false,
          hideOnSinglePage: true,
        }}
      />

      <FarmerPayAddModal
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchTableData}
        handleFetch2={fetchCardData}
        prodd={prodd}
      />

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="info"
        btnTitle="Push"
      />
    </div>
  );
}

export default FarmerPayTable;
